import { Controller } from "@hotwired/stimulus";
import ApexCharts from "apexcharts";

export default class extends Controller {
  static values = {
    series: Array,
  }
  connect() {
    console.log(this.seriesValue)
    var options = {
      series: this.seriesValue,
      chart: {
        type: "line",
        width: 80,
        height: 30,
        sparkline: {
          enabled: true,
        },
      },
      stroke: {
        curve: 'smooth',
        width: [1.5]
      },
      colors: ["rgba(255, 90, 41)"],
      xaxis: {
        crosshairs: {
          width: 1,
        },
      },
      tooltip: {
        fixed: {
          enabled: false,
        },
        x: {
          show: false,
        },
        y: {
          title: {
            formatter: function (seriesName) {
              return "";
            },
          },
        },
        marker: {
          show: false,
        },
      },
    };
    var chart = new ApexCharts(this.element, options);
    chart.render();
  }
}
